/**
 * EZ-INK color swatches:
 * - Collection cards: hover previews color on hero image; click locks selection
 * - PDP: select Color option (drives gallery filter + variant)
 */
(function () {
  function getCardImage(wrap) {
    var targetId = wrap.getAttribute("data-target-img");
    var img = targetId ? document.getElementById(targetId) : null;
    if (!img) {
      var card = wrap.closest(".product-card") || wrap.closest(".grid-view-item");
      if (card) {
        img = card.querySelector(
          "img[data-image], img.grid-view-item__image, img.list-view-item__image"
        );
      }
    }
    return img;
  }

  function setCardImage(img, url) {
    if (!img || !url) return;
    img.setAttribute("src", url);
    if (img.getAttribute("data-src")) img.setAttribute("data-src", url);
    if (img.getAttribute("data-srcset")) img.removeAttribute("data-srcset");
    if (img.getAttribute("srcset")) img.removeAttribute("srcset");
    img.classList.add("lazyloaded");
    img.classList.remove("lazyload", "lazyloading");
  }

  function getSelectedSwatch(wrap) {
    return (
      wrap.querySelector(".ezink-card-swatch.is-selected") ||
      wrap.querySelector(".ezink-card-swatch")
    );
  }

  function rememberBaseImage(wrap, img) {
    if (!wrap || !img) return;
    if (!wrap.dataset.baseImageUrl) {
      wrap.dataset.baseImageUrl =
        img.getAttribute("src") || img.getAttribute("data-src") || "";
    }
  }

  function applySelectedImage(wrap) {
    var img = getCardImage(wrap);
    if (!img) return;
    var sel = getSelectedSwatch(wrap);
    var url =
      (sel && sel.getAttribute("data-image-url")) || wrap.dataset.baseImageUrl || "";
    if (url) setCardImage(img, url);
  }

  function previewSwatch(wrap, btn) {
    var img = getCardImage(wrap);
    if (!img) return;
    rememberBaseImage(wrap, img);
    var url = btn.getAttribute("data-image-url");
    if (url) setCardImage(img, url);
    wrap.querySelectorAll(".ezink-card-swatch").forEach(function (el) {
      el.classList.toggle("is-hover", el === btn);
    });
  }

  function clearHover(wrap) {
    wrap.querySelectorAll(".ezink-card-swatch").forEach(function (el) {
      el.classList.remove("is-hover");
    });
    applySelectedImage(wrap);
  }

  function onCardSwatchClick(e) {
    var btn = e.target.closest(".ezink-card-swatch");
    if (!btn) return;
    var wrap = btn.closest("[data-ezink-card-swatches]");
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();

    var img = getCardImage(wrap);
    rememberBaseImage(wrap, img);
    var url = btn.getAttribute("data-image-url");
    if (img && url) setCardImage(img, url);

    wrap.querySelectorAll(".ezink-card-swatch").forEach(function (el) {
      el.classList.toggle("is-selected", el === btn);
      el.classList.remove("is-hover");
      el.setAttribute("aria-pressed", el === btn ? "true" : "false");
    });
    // Commit selected as new base for leave-restore
    if (url) wrap.dataset.baseImageUrl = url;
  }

  function findColorSelect(section) {
    if (!section) return null;
    var marked = section.querySelector("[data-ezink-color-select]");
    if (marked) return marked;
    var selects = section.querySelectorAll("select.single-option-selector");
    for (var i = 0; i < selects.length; i++) {
      var lab = section.querySelector('label[for="' + selects[i].id + '"]');
      var n = ((lab && lab.textContent) || "").trim().toLowerCase();
      if (n === "color" || n === "colour") return selects[i];
    }
    return null;
  }

  function syncPdpSwatches(section, color) {
    if (!section || !color) return;
    section.querySelectorAll(".ezink-pdp-swatch").forEach(function (el) {
      var on = el.getAttribute("data-color") === color;
      el.classList.toggle("is-selected", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
      if (on && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    });
    section.querySelectorAll("[data-ezink-selected-color]").forEach(function (labelEl) {
      labelEl.textContent = color;
    });
  }

  function onPdpSwatchClick(e) {
    var btn = e.target.closest(".ezink-pdp-swatch");
    if (!btn) return;
    var wrap = btn.closest("[data-ezink-pdp-swatches]");
    if (!wrap) return;
    e.preventDefault();

    var color = btn.getAttribute("data-color");
    if (!color) return;

    var section = wrap.closest("[data-section-type='product']") || document;
    var select = findColorSelect(section);
    if (!select) {
      var selects = section.querySelectorAll("select.single-option-selector");
      for (var j = 0; j < selects.length; j++) {
        for (var k = 0; k < selects[j].options.length; k++) {
          if (selects[j].options[k].value === color) {
            select = selects[j];
            break;
          }
        }
        if (select) break;
      }
    }
    if (select) {
      select.value = color;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    syncPdpSwatches(section, color);
  }

  function onColorSelectChange(e) {
    var t = e.target;
    if (!t || t.tagName !== "SELECT") return;
    var section = t.closest("[data-section-type='product']") || document;
    var select = t.hasAttribute("data-ezink-color-select") ? t : null;
    if (!select) {
      var lab = section.querySelector('label[for="' + t.id + '"]');
      var n = ((lab && lab.textContent) || "").trim().toLowerCase();
      if (n !== "color" && n !== "colour") return;
      select = t;
    }
    if (!select.value) return;
    syncPdpSwatches(section, select.value);
  }

  function getVideoModal() {
    return document.querySelector("[data-ezink-video-modal]");
  }

  function closeVideoModal() {
    var modal = getVideoModal();
    if (!modal) return;
    var player = modal.querySelector("video");
    if (player) {
      player.pause();
      player.removeAttribute("src");
      player.load();
    }
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  function openVideoModal(src, poster) {
    var modal = getVideoModal();
    if (!modal || !src) return;
    var player = modal.querySelector("video");
    if (!player) return;
    player.muted = true;
    player.defaultMuted = true;
    player.setAttribute("muted", "");
    player.playsInline = true;
    if (poster) player.setAttribute("poster", poster);
    player.src = src;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    var play = player.play();
    if (play && typeof play.catch === "function") play.catch(function () {});
  }

  function onVideoUiClick(e) {
    var closer = e.target.closest("[data-ezink-video-close]");
    if (closer) {
      e.preventDefault();
      closeVideoModal();
      return;
    }
    var opener = e.target.closest("[data-ezink-video-open]");
    if (opener) {
      e.preventDefault();
      openVideoModal(
        opener.getAttribute("data-ezink-video-src"),
        opener.getAttribute("data-ezink-video-poster")
      );
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ezink-card-swatches]")) onCardSwatchClick(e);
    if (e.target.closest("[data-ezink-pdp-swatches]")) onPdpSwatchClick(e);
    onVideoUiClick(e);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeVideoModal();
  });

  if (!window.__ezinkVideoPopupInit) {
    var _s = document.createElement("script");
    _s.src = "https://www.nextlinq.com/ezink-video-popup.js?v=20260816c";
    _s.defer = true;
    document.head.appendChild(_s);
  }

  // Dropdown Color change must keep gallery swatches + "Color: …" label in sync
  document.addEventListener("change", onColorSelectChange, true);

  if (window.jQuery) {
    jQuery(document).on("variantChange", function (evt) {
      var root =
        (evt && evt.target && evt.target.closest &&
          evt.target.closest("[data-section-type='product']")) ||
        document.querySelector("[data-section-type='product']");
      if (!root) return;
      var select = findColorSelect(root);
      if (select && select.value) syncPdpSwatches(root, select.value);
    });
  }

  // Hover preview on collection grid cards
  document.addEventListener(
    "mouseover",
    function (e) {
      var btn = e.target.closest(".ezink-card-swatch");
      if (!btn) return;
      var wrap = btn.closest("[data-ezink-card-swatches]");
      if (!wrap) return;
      // Only fire when entering the button (not bubbling from children — buttons are empty)
      if (e.relatedTarget && btn.contains(e.relatedTarget)) return;
      previewSwatch(wrap, btn);
    },
    true
  );

  document.addEventListener(
    "mouseout",
    function (e) {
      var btn = e.target.closest(".ezink-card-swatch");
      if (!btn) return;
      var wrap = btn.closest("[data-ezink-card-swatches]");
      if (!wrap) return;
      // Leaving one swatch for another: mouseover on the next will update
      var to = e.relatedTarget;
      if (to && wrap.contains(to) && to.closest && to.closest(".ezink-card-swatch")) {
        return;
      }
      // Leaving the swatch row entirely → restore selected
      if (to && wrap.contains(to)) return;
      clearHover(wrap);
    },
    true
  );

  // When leaving the whole swatch strip, always restore
  document.addEventListener(
    "mouseleave",
    function (e) {
      var wrap = e.target.closest && e.target.closest("[data-ezink-card-swatches]");
      if (!wrap || e.target !== wrap) return;
      clearHover(wrap);
    },
    true
  );
})();
